import Heading from 'components/text/Heading';
import PropTypes from 'prop-types';
import React from 'react';
import Tag from 'components/text/Tag';
import { above } from 'utils/mediaqueries';
import styled from 'libs/styled';

const Wrapper = styled('div')`
    margin-top: 16px;

    ${above.sm} {
        margin-top: 24px;
    }
`;

const Content = ({ heading = '', headingTag = '', tag = '' }) => (
    <Wrapper>
        {heading && (
            <Heading withAnimation as={headingTag} size="lg" margin="0">
                {heading}
            </Heading>
        )}
        {tag && (
            <Tag withAnimation marginTop={['16px', null, '24px']}>
                {tag}
            </Tag>
        )}
    </Wrapper>
);

Content.propTypes = {
    heading: PropTypes.string,
    headingTag: PropTypes.string,
    tag: PropTypes.string,
};

export default Content;
